import { getUrlApi } from '../utilities/util';
import ApiHandler from './ApiHandlers/ApiHandler'; 
 
export const baseURL = String(getUrlApi());

export default class PlantApi { 
    /**
     * @deprecated Use GetPlantsFilter instead for better performance with server-side pagination.
     */
    static async GetAllPlants(): Promise<any> {
        return ApiHandler(baseURL).get("/v1/plants/all");
    };  

    static async GetPlantsFilter(params: any): Promise<any> {
        return ApiHandler(baseURL).get("/v1/plants/filter", { params });
    }

    static async GetPlantsByCompanyId(companyId: string): Promise<any> {
        return ApiHandler(baseURL).get(
          `/v1/plants/filter?companyIds=${encodeURIComponent(companyId)}`,
        );
    }
    
    static async GetPlantById(id: string): Promise<any> {
        return ApiHandler(baseURL).get("/v1/plants/" + id);
    }; 

    static async CreatePlant(companyId: string, name: string): Promise<any> { 
        return ApiHandler(baseURL).post("/v1/plants", { companyId, name })
    }

    static async UpdatePlant(id: string, companyId: string, name: string): Promise<any> {
        return ApiHandler(baseURL).put(`/v1/plants/${id}`, { companyId, name }); 
    }

    static async DeletePlant(id: string): Promise<any> {
        return ApiHandler(baseURL).delete(`/v1/plants/${id}`);
    } 
}
